<template>
	<div class="text-primary checkoutTotalComponent">
		<div
			v-if="installments && Object.values(installments).length > 1"
			class="flex justify-between">
			<p class="font-serif text-3xl">{{ $t("totalDue") }}</p>
			<p class="font-serif text-3xl">{{ currency.symbol }}{{ parseFloat(installments[0].amount).toFixed(2) }}</p>
		</div>

		<div
			v-else
			class="flex justify-between">
			<p class="font-serif text-3xl">{{ $t("total") }}</p>
			<p class="font-serif text-3xl">{{ currency.symbol }}{{ parseFloat(total).toFixed(2) }}</p>
		</div>
	</div>
</template>

<script setup>
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"
	import { useCartStore } from "~/stores/CartStore"

	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)

	const cartStore = useCartStore()
	const { total, installments } = storeToRefs(cartStore)
</script>

<style scoped></style>
